import { createContext } from 'react';
import { Product } from '@socialflows/shared-lib';

export const DEFAULT_PRODUCT: Product = {
  id: '',
  accountId: '',
  label: '',
  description: '',
  slug: '',
  categoryId: undefined,
  brandId: undefined,
  tags: [],
  media: [],
  variants: [],
  price: 0,
  compareAtPrice: undefined,
  costPerItem: undefined,
  status: 'DRAFT',
  isVisible: true,
  metaTitle: undefined,
  metaDescription: undefined,
  customFields: undefined,
  createdAt: '',
  updatedAt: '',
};

export type ProductContextValue = {
  product: Product;
  setProduct: (product: Product) => void;
  originalProduct: Product;
  isDirty: boolean;
};

export const ProductContext = createContext<ProductContextValue>({
  product: DEFAULT_PRODUCT,
  setProduct: () => {},
  originalProduct: DEFAULT_PRODUCT,
  isDirty: false,
});
